const style = (theme) => {
  const output = {
    root: {
      minHeight: '100%',
      background: theme.colors[7],
      color: theme.colors[1],
      paddingTop: 200,
    },
    wrapper: {
      extend: theme.wrapper,
      display: 'flex',
    },
    title: {
      fontWeight: 600,
      fontSize: 30,
      marginBottom: 100,
    },
    text: {
      fontWeight: 300,
      fontSize: 18,
      lineHeight: 1.5,
      display: 'flex',
      flexDirection: 'column',
      '& a': {
        color: theme.colors[1],
        textDecoration: 'underline',
      },
    },
  }

  /*------------------------------
  MD
  ------------------------------*/
  output[theme.mediaInverse.md] = {
  }

  /*------------------------------
  SM
  ------------------------------*/
  output[theme.mediaInverse.sm] = {
  }

  return output
}

export default style
